import * as React from 'react';
import PortalIdParser from 'PortalIdParser';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UITruncateString from 'UIComponents/text/UITruncateString';
import useContentPage from 'flow-doctor-lib/hooks/useContentPage';
import SkeletonText from 'flow-doctor-lib/components/common/SkeletonText';
import EnrollmentChecksButton from 'flow-doctor-lib/components/timeline/EnrollmentChecksButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FormSubmissionTimelineItemLabel = ({
  logItem
}) => {
  // There's a weird phenomenon where `pageId` can be a string literal "null", and we want to avoid requesting
  // the page in this case because it doesn't make any sense.
  const hasValidPage = logItem.data.pageId && logItem.data.pageId !== 'null';
  const {
    data: pageData,
    loading: pageLoading,
    error: pageError
  } = useContentPage({
    portalId: PortalIdParser.get(),
    pageId: logItem.data.pageId
  }, {
    skip: !hasValidPage
  });
  if (!pageError && hasValidPage && (pageLoading || !pageData)) {
    return /*#__PURE__*/_jsx(SkeletonText, {
      width: 200
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(UITruncateString, {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: hasValidPage ? 'flow-doctor-lib.flows.objectLifecycle.formSubmissionHistory.label.withPage' : logItem.data.pageTitle ? 'flow-doctor-lib.flows.objectLifecycle.formSubmissionHistory.label.withPageTitle' : 'flow-doctor-lib.flows.objectLifecycle.formSubmissionHistory.label.withoutPage',
        options: {
          formName: logItem.data.formTitle,
          pageName: pageData ? pageData.label : logItem.data.pageId,
          pageTitle: logItem.data.pageTitle
        }
      })
    }), /*#__PURE__*/_jsx(EnrollmentChecksButton, {
      timelineItem: logItem
    })]
  });
};
export default FormSubmissionTimelineItemLabel;